import React from 'react';
import { useUser } from '../contexts/UserContext';

const AuthGate = ({ children }) => {
  const { loading } = useUser();

  if (!loading) {
    return <>{children}</>;
  }
};

export default AuthGate;